// import * as React from 'react';
// import {
//   createBrowserRouter,
//   createRoutesFromChildren,
//   matchRoutes,
//   useLocation,
//   useNavigationType,
// } from "react-router";
// import * as Sentry from "@sentry/react";

// import { createRoot } from 'react-dom/client';
// import { createInstance, Piral, createStandardApi } from 'piral';
// import { layout, errors } from './layout';
// import { createAdalApi } from '@cannon-design/piral-adal';
// import { client } from './adal';
// import { createCDHelperApi, PiletCDHelperApi } from './extensions/cdHelpers';
// import { createFetchApi } from 'piral-fetch';
// import * as mui from '@mui/material';
// import * as emotionStyled from '@emotion/styled';
// import * as emotionReact from '@emotion/react';
// import * as xcharts from '@mui/x-charts';
// import * as xdatagrid from '@mui/x-data-grid';

// declare module 'piral-core/lib/types/custom' {
//   interface PiletCustomApi extends PiletCDHelperApi { }
// }

// Sentry.init({
//   dsn: "https://e0477dbd494fb42d509f126a6abcc90c@o4507855332900864.ingest.us.sentry.io/4509374285283328",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     // Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//     Sentry.reactRouterV7BrowserTracingIntegration({
//       useEffect: React.useEffect,
//       useLocation,
//       useNavigationType,
//       createRoutesFromChildren,
//       matchRoutes,
//     })
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/cannon-shell\.azurewebsites\.net\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// // change to your feed URL here (either using feed.piral.cloud or your own service)
// const feedUrl = 'https://cannon-pilet-feed-c0hkbmf3e8hzdsfm.centralus-01.azurewebsites.net/api/feed'; // 'http://localhost:3000/api/feed'; //'https://feed.piral.cloud/api/v1/pilet/empty';

// const instance = createInstance({
//   state: {
//     components: layout,
//     errorComponents: errors,
//   },
//   shareDependencies: (deps) => ({
//     ...deps,
//     '@mui/material': mui,
//     '@emotion/styled': emotionStyled,
//     '@emotion/react': emotionReact,
//     '@mui/x-charts': xcharts,
//     "@mui/x-data-grid": xdatagrid
//   }),
//   plugins: [...createStandardApi(),
//   createAdalApi(client),
//   createFetchApi({
//     base: 'https://dev-cannondesign-api.azure-api.net/',
//     default: {
//       headers: {
//         'CannonDesign-Apim-Subscription-Key': '963134e5a0984349bc6c93002f384ffa',
//         'Content-Type': 'application/json',
//       },
//     }
//   }),
//   createCDHelperApi({}),
//   ],
//   requestPilets() {
//     return fetch(feedUrl)
//       .then((res) => res.json())
//       .then((res) => res.items);
//   }
// });

// export const piralApi = instance.root;
// window["cdPiralApi"] = piralApi;
// const root = createRoot(document.querySelector('#app'));

// // Parse URL parameters from hash for implicit flow
// const hashParams = new URLSearchParams(window.location.hash.substring(1));

// // Check if we're in the middle of an auth callback
// const isAuthCallback =
//   window.location.hash.includes('id_token') ||
//   hashParams.has('code') ||
//   hashParams.has('id_token') ||
//   hashParams.has('error');

// // Check if auth is already in progress to prevent duplicate login attempts
// const isAuthInProgress = sessionStorage.getItem('msal.interaction.status') === 'interaction_in_progress';

// // Store the original URL for redirecting back after login
// const storeCurrentPath = () => {
//   const currentPath = window.location.pathname + window.location.search;
//   if (currentPath !== '/' && !isAuthCallback) {
//     sessionStorage.setItem('redirectPath', currentPath);
//   }
// };

// // Get the stored redirect path or default to '/'
// const getRedirectPath = () => {
//   const path = sessionStorage.getItem('redirectPath') || '/';
//   sessionStorage.removeItem('redirectPath'); // Clean up
//   return path;
// };

// // Main authentication and rendering logic
// const renderApp = () => {
//   root.render(<Piral instance={instance} />);
// };

// client.ready.then(() => {
//   // Store current path before any redirects happen
//   storeCurrentPath();

//   // Special case for auth page - skip auth flow
//   if (location.pathname === '/auth') {
//     renderApp();
//   } else {
//     if (client.account()) {
//       // User is logged in, clear any auth flags and render app
//       console.log('User is logged in, rendering app');
//       sessionStorage.removeItem('auth_attempt');

//       // If this is a callback from authentication, redirect to the original URL
//       if (isAuthCallback && window.location.pathname === '/') {
//         const redirectPath = getRedirectPath();
//         if (redirectPath !== '/' && redirectPath !== window.location.pathname) {
//           console.log('Redirecting to original path:', redirectPath);
//           window.location.href = redirectPath;
//           return; // Skip rendering as we're redirecting
//         }
//       }

//       renderApp();
//     } else if (!isAuthCallback && !isAuthInProgress) {
//       // No active account, not in a callback, and no auth in progress - attempt login
//       console.log('No active session, starting login flow');
//       try {
//         // Set flag to prevent multiple attempts
//         sessionStorage.setItem('auth_attempt', 'true');
//         client.login();
//       } catch (error) {
//         console.error('Auth error:', error);
//         // If login fails, clear flag so user can try again
//         sessionStorage.removeItem('auth_attempt');
//         // Render anyway to show error state or login UI
//         renderApp();
//       }
//     } else if (isAuthCallback && hashParams.has('error')) {
//       // Handle auth errors
//       console.error('Auth callback error:', hashParams.get('error_description') || hashParams.get('error'));
//       sessionStorage.removeItem('auth_attempt');
//       // Redirect to home after error
//       if (window.location.hash) {
//         // window.location.href = window.location.pathname;
//         renderApp();
//       } else {
//         renderApp();
//       }
//     } else {
//       // Either auth callback is processing or auth is in progress
//       console.log('Auth callback processing or auth in progress');

//       // If we're in a callback but no error, we should render the app
//       // This allows the authentication library to process the callback
//       if (isAuthCallback) {
//         console.log('Auth callback detected, rendering app to process callback');
//         renderApp();
//       } else {
//         console.log('Waiting for auth process to complete');
//         // Optionally show a loading state
//         root.render(<div>Loading...</div>);
//       }
//     }
//   }
// });

// // // In your Piral instance setup
// // export function createPiralInstance() {
// //   const account = /* get user account here */;
// //   return createInstance({
// //     plugins: [createExtendedApi(account)],
// //     // ...other config...
// //   });
// // }

import * as React from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import * as Sentry from "@sentry/react";

import { createRoot } from "react-dom/client";
import { createInstance, Piral, createStandardApi } from "piral";
import { layout, errors } from "./layout";
import { createAdalApi } from "@cannon-design/piral-adal";
import { client } from "./adal"; // This is your AdalClient instance
import { createCDHelperApi, PiletCDHelperApi } from "./extensions/cdHelpers";
import { createFetchApi } from "piral-fetch";
import * as mui from "@mui/material";
import * as emotionStyled from "@emotion/styled";
import * as emotionReact from "@emotion/react";
import * as xcharts from "@mui/x-charts";
import * as xdatagrid from "@mui/x-data-grid";
import { loadConfig } from "./config";

// ... (your declare module and Sentry setup remain the same) ...

declare module "piral-core/lib/types/custom" {
  interface PiletCustomApi extends PiletCDHelperApi {}
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  release: import.meta.env.VITE_SENTRY_RELEASE,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/cannon-shell\.azurewebsites\.net\/api/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const feedUrl =
  "https://cannon-pilet-feed-c0hkbmf3e8hzdsfm.centralus-01.azurewebsites.net/api/feed";

export let piralApi: any;

async function init() {
  const config = await loadConfig();

  const instance = createInstance({
    state: {
      components: layout,
      errorComponents: errors,
    },
    shareDependencies: (deps) => ({
      ...deps,
      "@mui/material": mui,
      "@emotion/styled": emotionStyled,
      "@emotion/react": emotionReact,
      "@mui/x-charts": xcharts,
      "@mui/x-data-grid": xdatagrid,
    }),
    plugins: [
      ...createStandardApi(),
      createAdalApi(client), // Your AdalClient instance is passed here
      createFetchApi({
        base: config.apiUrl,
        default: {
          headers: {
            "CannonDesign-Apim-Subscription-Key":
              "963134e5a0984349bc6c93002f384ffa",
            "Content-Type": "application/json",
          },
        },
      }),
      createCDHelperApi({}),
    ],
    requestPilets() {
      console.log("Requesting pilets from feed URL:", feedUrl);
      return fetch(feedUrl)
        .then((res) => res.json())
        .then((res) => {
          let apps = res.items.filter((item) => {
            return client.account().idTokenClaims?.roles?.includes(item.name);
          });
          return apps;
        });
    },
  });

  piralApi = instance.root;
  window["cdPiralApi"] = piralApi;

  const root = createRoot(document.querySelector("#app"));

  const hashParams = new URLSearchParams(window.location.hash.substring(1));

  const isAuthCallback =
    window.location.hash.includes("id_token") ||
    hashParams.has("code") ||
    hashParams.has("id_token") ||
    hashParams.has("error");

  const isAuthInProgress =
    sessionStorage.getItem("msal.interaction.status") ===
    "interaction_in_progress";

  const storeCurrentPath = () => {
    const currentPath = window.location.pathname + window.location.search;
    if (currentPath !== "/" && !isAuthCallback) {
      sessionStorage.setItem("redirectPath", currentPath);
    }
  };

  const getRedirectPath = () => {
    const path = sessionStorage.getItem("redirectPath") || "/";
    sessionStorage.removeItem("redirectPath");
    return path;
  };

  const renderApp = () => {
    root.render(<Piral instance={instance} />);
  };

  // --- MSAL/ADAL Authentication Handling ---
  client.ready
    .then(() => {
      // storeCurrentPath(); // You might still want this for general direct navigation, but less critical for this specific flow.

      // The 'msal_force_login_on_load' and 'msal_select_account_on_load' checks are REMOVED here.
      // The 'handleUseAnotherAccount' in SideMenu.tsx now handles the "another account" flow via popup directly.

      if (location.pathname === "/auth") {
        console.log("[MSAL Flow] On /auth path, rendering app directly.");
        renderApp();
      } else {
        if (client.account()) {
          console.log("[MSAL Flow] User is logged in, rendering app.");
          sessionStorage.removeItem("auth_attempt");

          // Your existing redirect logic after a successful auth callback
          if (isAuthCallback && window.location.pathname === "/") {
            const redirectPath = getRedirectPath();
            if (
              redirectPath !== "/" &&
              redirectPath !== window.location.pathname
            ) {
              console.log(
                "[MSAL Flow] Auth callback completed, redirecting to original path:",
                redirectPath
              );
              window.location.href = redirectPath;
              return;
            }
          }
          renderApp();
        } else if (!isAuthCallback && !isAuthInProgress) {
          console.log(
            "[MSAL Flow] No active session, not a callback, and not in progress. Starting default login flow."
          );
          try {
            sessionStorage.setItem("auth_attempt", "true");
            // This is your standard initial login for when no user is logged in at all.
            // It typically defaults to silent SSO or interactive redirect/popup based on MSAL config.
            client.login();
          } catch (error) {
            console.error(
              "[MSAL Error] Auth error during initial login attempt:",
              error
            );
            sessionStorage.removeItem("auth_attempt");
            renderApp();
          }
        } else if (isAuthCallback && hashParams.has("error")) {
          console.error(
            "[MSAL Flow] Auth callback error detected:",
            hashParams.get("error_description") || hashParams.get("error")
          );
          sessionStorage.removeItem("auth_attempt");
          renderApp();
        } else {
          console.log(
            "[MSAL Flow] Auth callback processing or auth in progress. Waiting..."
          );
          if (isAuthCallback) {
            console.log(
              "[MSAL Flow] Auth callback detected, rendering app to allow MSAL to process."
            );
            renderApp();
          } else {
            console.log(
              "[MSAL Flow] Waiting for auth process to complete, showing loading state."
            );
            root.render(<div>Authenticating...</div>);
          }
        }
      }
    })
    .catch((error) => {
      console.error(
        "[MSAL Error] ADAL Client ready promise rejected, cannot proceed with authentication:",
        error
      );
      root.render(
        <div>Error initializing authentication. Please try again.</div>
      );
    });
}

init();
